import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'

import { GET, newFetch } from '../../../../helpers/fetch'

import { toWeekInt, toWeekDaysArrayFull } from '../../../../helpers/moment'

const PreferredTab = ({
  activeDate,
  activeWeek,
  activeClient,
  activeSite,
  associate
}) => {
  const [associatePreferredShifts, setAssociatePreferredShifts] = useState([])

  const fetchAssociatePreferredShifts = async day => {
    let api_path = `/associate/${associate.id}/preferences`
    let response = await newFetch(GET, api_path)

    if (response.success) {
      if (response.data.length > 0) {
        let start = moment(activeWeek.startDate).toDate()
        let end = moment(activeWeek.endDate).toDate()
        let filter = response.data
          .filter(preferred => {
            let date = new Date(preferred.date)
            return date >= start && date <= end
          })
          .sort((a, b) => new Date(a.date) - new Date(b.date))

        setAssociatePreferredShifts(filter)
      }
    }
  }

  useEffect(() => {
    if (associate) fetchAssociatePreferredShifts()
  }, [associate])

  const getWeekPreference = () => {
    if (activeWeek.startDate && activeClient) {
      return toWeekDaysArrayFull(
        activeWeek.startDate,
        activeClient.start_day
      ).map((day, index) => (
        <tr key={index}>
          <td className="border-right">
            <strong>{day.format('dddd DD/M')}</strong>
          </td>
          <td className="border-right text-center">
            <div className="d-flex flex-column">
              {associatePreferredShifts.filter(
                shift => shift.date === day.format('YYYY-MM-DD')
              ).length > 0
                ? associatePreferredShifts
                    .filter(shift => shift.date === day.format('YYYY-MM-DD'))
                    .map(shift => shift.site.name)
                    .filter(
                      (value, index, self) => self.indexOf(value) === index
                    )
                    .map(site => (
                      <Link to="/scheduler" key={site}>
                        <span className="badge rounded-pill bg-brand mb-1">
                          {site}
                        </span>
                      </Link>
                    ))
                : '-'}
            </div>
          </td>
          <td className="text-center">
            {associatePreferredShifts.filter(
              shift => shift.date === day.format('YYYY-MM-DD')
            ).length > 0
              ? associatePreferredShifts.find(
                  shift =>
                    shift.date === day.format('YYYY-MM-DD') &&
                    shift.is_available
                )
                ? associatePreferredShifts
                    .filter(shift => shift.date === day.format('YYYY-MM-DD'))
                    .map(shift => shift.shift.name)
                    .map(shift => {
                      return shift !== null
                        ? shift
                            .split(/\s/)
                            .reduce(
                              (response, word) =>
                              word,
                              ''
                            )
                        : ''
                    })
                    .join(', ')
                : 'NA'
              : '-'}
          </td>
        </tr>
      ))
    }
  }

  return (
    <div className="w-100 mt-4">
      <div className="table-responsive border rounded">
        <table className="table mb-0">
          <thead>
            <tr>
              <th className="border-top-0 border-right">
                Week {toWeekInt(activeWeek.startDate, activeClient.start_day)}
              </th>
              <th className="border-right text-center">Sites</th>
              <th className="border-top-0 text-center">Shift</th>
            </tr>
          </thead>
          <tbody>{getWeekPreference()}</tbody>
        </table>
      </div>
    </div>
  )
}

export default PreferredTab
